// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"Client-src-prime-main-components-NotFound__notFoundContainer--sczgw"};